import React, { useEffect, useState } from "react";
import "./MyTasks.css";
import TransLoader from "../../loader/TransLoader";
import CustomAlert from "../../custom_alert/CustomAlert";

export default function MyTasks() {
  const [config, setConfig] = useState(null);
  const [pendingTasks, setPendingTasks] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const empCode = sessionStorage.getItem("user_id");

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch(console.error);
  }, []);

  // Fetch tasks
  useEffect(() => {
    if (!config || !empCode) return;

    const fetchTasks = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${config.BASE_URL}${config.EMPLOYEE_TASKS}`, {
          method: "POST",
          credentials: "include",
          headers: { "X-Requested-With": "RC_EMP_NEW" },
          body: JSON.stringify({
            emp_code: empCode
          })
        });
        const data = await res.json();

        if (data.status === "success") {
          setPendingTasks(data.pending || []);
          setCompletedTasks(data.completed || []);
        } else {
          setAlertMessage(data.message || "Failed to fetch tasks.");
        }
      } catch (err) {
        console.error(err);
        setAlertMessage("Network error while fetching tasks.");
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [config, empCode]);

  // Handle show images modal
  const handleShowImages = (task) => {
    const imgs = [];
    for (let i = 1; i <= 5; i++) {
      if (task[`image${i}`]) {
        imgs.push(task[`image${i}`]);
      }
    }
    if (imgs.length > 0) {
      setSelectedImages(imgs);
      setCurrentImageIndex(0);
      setShowModal(true);
    } else {
      setAlertMessage("No images available for this task.");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImages([]);
    setCurrentImageIndex(0);
  };

  const showNextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % selectedImages.length);
  };

  const showPrevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + selectedImages.length) % selectedImages.length);
  };

  // Render table
  const renderTable = (tasks, title) => (
    <div className="task-section">
      <h3>{title}</h3>
      <table className="task-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Task ID</th>
            <th>Job Title</th>
            <th>Description</th>
            <th>Given Date</th>
            <th>Target Date</th>
            <th>Status</th>
            <th>Images</th>
          </tr>
        </thead>
        <tbody>
          {tasks.length > 0 ? (
            tasks.map((task, index) => (
              <tr key={task.task_id}>
                <td>{index + 1}</td>
                <td>{task.task_id}</td>
                <td>{task.job_title}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>
                  {task.job_description}
                </td>
                <td>{task.start_date}</td>
                <td>{task.target_date}</td>
                <td className={task.task_status === 1 ? "status-completed" : "status-pending"}>
                  {task.task_status === 1 ? "Completed" : "Pending"}
                </td>

                <td>
                  <button onClick={() => handleShowImages(task)}>View Images</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="no-data">
                No {title.toLowerCase()} available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  if (loading) return <TransLoader />;

  return (
    <>
      <div className="content-card">
        {renderTable(pendingTasks, "Pending Tasks")}
        {renderTable(completedTasks, "Completed Tasks")}



      </div>
      <CustomAlert message={alertMessage} onClose={() => setAlertMessage("")} />
      {/* Modal for images */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <span className="close-btn" onClick={handleCloseModal}>
              &times;
            </span>
            <div className="image-container">
              <button className="nav-btn prev" onClick={showPrevImage}>
                &#8592;
              </button>
              <img
                src={`data:image/jpeg;base64,${selectedImages[currentImageIndex]}`}
                alt={`Task Image ${currentImageIndex + 1}`}
              />
              <button className="nav-btn next" onClick={showNextImage}>
                &#8594;
              </button>
            </div>
            <p>
              Image {currentImageIndex + 1} of {selectedImages.length}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
